import {useQuery} from '@tanstack/react-query';
import {fetchAuditActions, fetchAuditLog} from './audit-log-api';

/* ---------------------- LIST (رخدادها) ---------------------- */
export const useAuditLog = (page = 0, pageSize = 20, filters = {}) =>
    useQuery({
        queryKey: ['audit-log', page, pageSize, filters],
        queryFn: () => fetchAuditLog(page, pageSize, filters),
        keepPreviousData: true,
    });

/* ---------------------- ACTION VOCABULARY ---------------------- */
export const useAuditActions = () =>
    useQuery({
        queryKey: ['audit-actions'],
        queryFn: fetchAuditActions,
        // The vocabulary only changes when the application is redeployed.
        staleTime: 60 * 60 * 1000,
    });

/*
 * There are deliberately no create/update/delete hooks here. The audit trail is append-only —
 * the server exposes no mutation endpoint, and adding one on this side would only produce a
 * button that 404s.
 */
